import React from 'react';
import { constants } from '@apollo/core';
import Label from '../../../shared/components/I18n/Label';
import Odds from '../../../shared/components/Odds';
import { isTBD } from '../../../core/utils';

const { REJECTION_REASON } = constants;

const MyBetsItemOdds = ({
  outcomes,
  betOdds,
  originalBetOdds,
  rejectionReason,
  defaultOdds = null,
}) => {
  if (!betOdds) {
    return defaultOdds;
  }

  if (isTBD({ outcomes }) || betOdds <= 1) {
    return <Label message='tbd' />;
  }

  if (originalBetOdds && originalBetOdds !== betOdds) {
    if (rejectionReason === REJECTION_REASON.ODDS_REDUCED) {
      return (
        <>
          <div className='odd__original'>
            <Odds value={originalBetOdds} decimal={3} minDecimal={2} />
          </div>
          <div className='odd__default'>
            <span>
              <Odds value={betOdds} decimal={3} minDecimal={2} />
            </span>
          </div>
        </>
      );
    }
    // multi boosted
    return (
      <>
        <div className='odd__default'>
          <span>
            <Odds value={betOdds} decimal={3} minDecimal={2} />
          </span>
        </div>
        <div className='odd__original'>
          <Odds value={originalBetOdds} decimal={3} minDecimal={2} />
        </div>
      </>
    );
  }

  return <Odds value={betOdds} decimal={3} minDecimal={2} />;
};

export default MyBetsItemOdds;
